// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__13GXH","icon":"footer_icon__14Rcf","iconContainer":"footer_iconContainer__1kZ45"};